import { newLogger } from "@/utils/util";
import axios from "axios";
import Vue from "vue";

let logger = newLogger("AdministrationUiConfigStore");

const urls = {
  bnplInstanceType: "/api/administration/ui-config/bnpl-instance-type",
};

const initState = () => {
  return {
    uiConfig: {},
  };
};

const actions = {
  fetchBnplInstanceType: async ({ commit }) => {
    try {
      let { data } = await axios.get(urls.bnplInstanceType);
      commit("saveBnplInstanceType", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveBnplInstanceType: (state, data) => {
    Vue.set(state.uiConfig, "bnplInstanceType", data);
  },
};

const getters = {
  getBnplInstanceType: (state) => {
    return "MERCHANT_FINANCE";
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
